import { BaseReducer } from '@hobs/utils/baseReducer';
import { GET, CLEAR, FOR_SUBMIT, UPDATE_KITCHEN_FOR_SUBMIT, QUERY_MEAL_PLANNER_LOCATIONS } from '@hobs/constants/mealPlanner';

class MealPlanner extends BaseReducer {
  static defaultState = {
    serviceRequests: [],
    forSubmit: { units: [], kitchens: [], sendingNations: [] },
    kitchenForSubmit: [],
    mealPlannerLocations: []
  };

  constructor() {
    super(MealPlanner.defaultState);

    this.actionMap = {
      [GET.SUCCESS]: this.getServiceRequests,
      [CLEAR.SUCCESS]: this.clearServiceRequests,
      [FOR_SUBMIT.SUCCESS]: this.getForSubmit,
      [UPDATE_KITCHEN_FOR_SUBMIT.SUCCESS]: this.getKitchenForSubmit,
      [QUERY_MEAL_PLANNER_LOCATIONS.SUCCESS]: this.getMealPlannerLocations
    };
  }

  getServiceRequests = (state, action) => {
    return Object.assign({}, state, { serviceRequests: action.response });
  };

  getForSubmit = (state, action) => {
    return Object.assign({}, state, { forSubmit: action.response });
  };

  clearServiceRequests = state => {
    return Object.assign({}, state, { serviceRequests: [] });
  };

  getKitchenForSubmit = (state, action) => {
    return Object.assign({}, state, { kitchenForSubmit: action.response });
  };

  getMealPlannerLocations = (state, action) => {
    return Object.assign({}, state, { mealPlannerLocations: action.response });
  };
}
export default new MealPlanner().reducer;
